import Login from "./pages/Login";
import Signup from "./pages/Signup";
import InstallMobile from "./pages/InstallMobile";
import AuthCallback from "./pages/AuthCallback";
import MobileKiosk from "./pages/MobileKiosk";
import { ForgotPassword, ResetPassword } from "./pages/Recovery";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientsMap from "./pages/ClientsMap";
import Collaborators from "./pages/Collaborators";
import Teams from "./pages/Teams";
import Schedule from "./pages/Schedule";
import MonthlyAgenda from "./pages/MonthlyAgenda";
import Reports from "./pages/Reports";
import FinanceReports from "./pages/FinanceReports";
import Finance from "./pages/Finance";
import Notifications from "./pages/Notifications";
import JobDetail from "./pages/JobDetail";
import MobileHome from "./pages/MobileHome";
import MyHistory from "./pages/MyHistory";
import Positions from "./pages/Positions";
import Profile from "./pages/Profile";
import Equipments from "./pages/Equipments";
import ExpenseTemplates from "./pages/ExpenseTemplates";
import Supplies from "./pages/Supplies";
import StatusColors from "./pages/StatusColors";
import NotificationSettings from "./pages/NotificationSettings";
import NotificationHistory from "./pages/NotificationHistory";
import MobileJobDetail from "./pages/MobileJobDetail";
import Estimates from "./pages/Estimates";
import PaymentsHistory from "./pages/PaymentsHistory";
import BookingRequests from "./pages/BookingRequests";
import CompanySettings from "./pages/CompanySettings";
import Receivables from "./pages/Receivables";
import Invoices from "./pages/Invoices";
import CustomInvoices from "./pages/CustomInvoices";
import ScheduleAudit from "./pages/ScheduleAudit";
import TodayOverview from "./pages/TodayOverview";
import Notes from "./pages/Notes";
import ScheduleRelease from "./pages/ScheduleRelease";
import SuperAdminTenants from "./pages/SuperAdminTenants";
import SuperAdminPlans from "./pages/SuperAdminPlans";
import SuperAdminCollaborators from "./pages/SuperAdminCollaborators";
import SuperAdminClients from "./pages/SuperAdminClients";
import SuperAdminMenus from "./pages/SuperAdminMenus";
import SuperAdminReleaseNotes from "./pages/SuperAdminReleaseNotes";
import SuperAdminHealthAudit from "./pages/SuperAdminHealthAudit";
import AuditLog from "./pages/AuditLog";
import TalentBank from "./pages/TalentBank";
import TalentMap from "./pages/TalentMap";
import SuperAdminTalentMap from "./pages/SuperAdminTalentMap";
import SuperAdminTalents from "./pages/SuperAdminTalents";
import TalentRegister from "./pages/TalentRegister";
import CollaboratorLanding from "./pages/CollaboratorLanding";
import FeaturesPage from "./pages/FeaturesPage";
import Billing, { BillingSuccess } from "./pages/Billing";
import { SuperAdminLayout } from "./components/SuperAdminLayout";

const SuperAdminTenantsPage = () => (
  <SuperAdminLayout>
    <SuperAdminTenants />
  </SuperAdminLayout>
);
const SuperAdminPlansPage = () => (
  <SuperAdminLayout>
    <SuperAdminPlans />
  </SuperAdminLayout>
);
const SuperAdminCollaboratorsPage = () => (
  <SuperAdminLayout>
    <SuperAdminCollaborators />
  </SuperAdminLayout>
);
const SuperAdminClientsPage = () => (
  <SuperAdminLayout>
    <SuperAdminClients />
  </SuperAdminLayout>
);
const SuperAdminMenusPage = () => (
  <SuperAdminLayout>
    <SuperAdminMenus />
  </SuperAdminLayout>
);
const SuperAdminAuditLog = () => (
  <SuperAdminLayout>
    <AuditLog superAdmin />
  </SuperAdminLayout>
);
const SuperAdminHealthAuditPage = () => (
  <SuperAdminLayout>
    <SuperAdminHealthAudit />
  </SuperAdminLayout>
);
const SuperAdminTalentMapPage = () => (
  <SuperAdminLayout>
    <SuperAdminTalentMap />
  </SuperAdminLayout>
);
const SuperAdminTalentsPage = () => (
  <SuperAdminLayout>
    <SuperAdminTalents />
  </SuperAdminLayout>
);

const STAFF = ["admin", "supervisor"];
const ADMIN_ONLY = ["admin"];

// Public routes (no auth required)
export const PUBLIC_ROUTES = [
  { path: "/login", element: Login },
  { path: "/signup", element: Signup },
  { path: "/instalar", element: InstallMobile },
  { path: "/instalar-celular", element: InstallMobile },
  { path: "/instalar-iphone", element: InstallMobile },
  { path: "/instalar-android", element: InstallMobile },
  { path: "/install/iphone", element: InstallMobile },
  { path: "/install/android", element: InstallMobile },
  { path: "/auth/callback", element: AuthCallback },
  { path: "/forgot-password", element: ForgotPassword },
  { path: "/reset-password", element: ResetPassword },
  { path: "/cadastro-colaborador", element: TalentRegister },
  { path: "/seja-colaborador", element: CollaboratorLanding },
  { path: "/trabalhe-conosco", element: CollaboratorLanding },
  { path: "/recursos", element: FeaturesPage },
];

// Protected routes: { path, element, roles?, menuKey? }
// - roles undefined => any authenticated user
// - roles defined => restricted to listed roles (e.g. STAFF)
// - menuKey => when present, super-admin can block the route per tenant via
//   /super-admin/menus (must match AVAILABLE_MENU_KEYS in platform_admin.py)
export const PROTECTED_ROUTES = [
  { path: "/mobile", element: MobileHome },
  { path: "/mobile/kiosk", element: MobileKiosk },
  { path: "/hoje", element: TodayOverview, roles: STAFF, menuKey: "today" },
  { path: "/clients", element: Clients, roles: STAFF, menuKey: "clients" },
  { path: "/clients/map", element: ClientsMap, roles: STAFF, menuKey: "clients" },
  { path: "/estimates", element: Estimates, roles: ADMIN_ONLY, menuKey: "estimates" },
  { path: "/booking-requests", element: BookingRequests, roles: STAFF, menuKey: "booking-requests" },
  { path: "/recebimentos", element: Receivables, roles: STAFF, menuKey: "receivables" },
  { path: "/a-receber", element: Invoices, roles: ADMIN_ONLY, menuKey: "invoices" },
  { path: "/faturas", element: CustomInvoices, roles: ADMIN_ONLY, menuKey: "estimates" },
  { path: "/configuracoes/empresa", element: CompanySettings, roles: ADMIN_ONLY, menuKey: "company-settings" },
  { path: "/collaborators", element: Collaborators, roles: STAFF, menuKey: "collaborators" },
  { path: "/banco-colaboradores", element: TalentBank, roles: STAFF },
  { path: "/mapa-colaboradores", element: TalentMap, roles: STAFF },
  { path: "/teams", element: Teams, roles: STAFF, menuKey: "teams" },
  { path: "/positions", element: Positions, roles: STAFF, menuKey: "positions" },
  { path: "/equipments", element: Equipments, roles: STAFF, menuKey: "equipments" },
  { path: "/supplies", element: Supplies, roles: STAFF, menuKey: "supplies" },
  { path: "/kits-compra", element: ExpenseTemplates, roles: STAFF, menuKey: "expenses" },
  { path: "/cores", element: StatusColors, roles: STAFF, menuKey: "status-colors" },
  { path: "/schedule", element: Schedule, menuKey: "schedule" },
  { path: "/schedule/month", element: MonthlyAgenda, roles: STAFF, menuKey: "schedule" },
  { path: "/schedule-release", element: ScheduleRelease, roles: ADMIN_ONLY, menuKey: "schedule-release" },
  { path: "/agenda/corrigir", element: ScheduleAudit, roles: ADMIN_ONLY, menuKey: "schedule" },
  { path: "/jobs/:id", element: JobDetail },
  { path: "/mobile/job/:id", element: MobileJobDetail },
  { path: "/reports", element: Reports, roles: STAFF },
  { path: "/finance/reports", element: FinanceReports, roles: STAFF, menuKey: "finance" },
  { path: "/finance/payments", element: PaymentsHistory, roles: ADMIN_ONLY, menuKey: "payments" },
  { path: "/finance", element: Finance, roles: STAFF, menuKey: "finance" },
  { path: "/notifications", element: Notifications },
  { path: "/notification-settings", element: NotificationSettings, roles: STAFF },
  { path: "/notification-history", element: NotificationHistory, roles: STAFF },
  { path: "/historico", element: MyHistory },
  { path: "/history", element: MyHistory },
  { path: "/perfil", element: Profile },
  { path: "/notas", element: Notes, roles: ADMIN_ONLY, menuKey: "notes" },
  { path: "/super-admin/tenants", element: SuperAdminTenantsPage, roles: ADMIN_ONLY },
  { path: "/super-admin/plans", element: SuperAdminPlansPage, roles: ADMIN_ONLY },
  { path: "/super-admin/collaborators", element: SuperAdminCollaboratorsPage, roles: ADMIN_ONLY },
  { path: "/super-admin/clients", element: SuperAdminClientsPage, roles: ADMIN_ONLY },
  { path: "/super-admin/menus", element: SuperAdminMenusPage, roles: ADMIN_ONLY },
  { path: "/super-admin/talent-map", element: SuperAdminTalentMapPage, roles: ADMIN_ONLY },
  { path: "/super-admin/talents", element: SuperAdminTalentsPage, roles: ADMIN_ONLY },
  { path: "/super-admin/release-notes", element: SuperAdminReleaseNotes, roles: ADMIN_ONLY },
  { path: "/super-admin/audit-log", element: SuperAdminAuditLog, roles: ADMIN_ONLY },
  { path: "/super-admin/health-audit", element: SuperAdminHealthAuditPage, roles: ADMIN_ONLY },
  { path: "/audit-log", element: AuditLog, roles: ADMIN_ONLY, menuKey: "audit-log" },
  { path: "/billing", element: Billing, roles: ADMIN_ONLY, menuKey: "billing" },
  { path: "/billing/success", element: BillingSuccess, roles: ADMIN_ONLY, menuKey: "billing" },
];

// Aliases — URLs alternativas em inglês que redirecionam para as canônicas em português
export const ROUTE_ALIASES = [
  { from: "/solicitations", to: "/booking-requests" },
  { from: "/employees", to: "/collaborators" },
  { from: "/configuracoes/cores", to: "/cores" },
];
